import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      }, 
    },
    {
      path: '/cobranca',
      name: 'cobranca',
      component: () => import('@/views/Cobranca.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Cobrança',
        breadcrumb: [
          {
            text: 'Cobrança',
            active: true,
          },
        ],
      }, 
    },
    {
      path: '/ordem',
      name: 'ordem',
      component: () => import('@/views/Ordem.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Ordem',
        breadcrumb: [
          {
            text: 'Ordem',
            active: true,
          },
        ],
      }, 
    },
    {
      path: '/transferencia',
      name: 'transferencia',
      component: () => import('@/views/Transferencia.vue'),
      meta: {
        requiresAuth: true,
        pageTitle: 'Transferência',
        breadcrumb: [
          {
            text: 'Transferência',
            active: true,
          },
        ],
      }, 
    },
    // {
    //   path: '/second-page',
    //   name: 'second-page',
    //   component: () => import('@/views/SecondPage.vue'),
    //   meta: {
    //     requiresAuth: true,
    //     pageTitle: 'Second Page',
    //     breadcrumb: [
    //       {
    //         text: 'Second Page',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    {
      path: '/',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/view/boleto',
      name: 'boleto',
      component: () => import('@/views/estabelecimentos/cobranca/Boleto.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})


router.beforeEach(async (to, from, next) => {

   var isAuthenticated = false
   let dataInicio = await new Date(JSON.parse(localStorage.getItem('logado_wise')));
    let dataTermino = await new Date(); 
    let diferencaTempo = await dataTermino.getTime() - dataInicio.getTime();
    
    if((diferencaTempo/1000) < JSON.parse(localStorage.getItem('tempo_wise'))){
       isAuthenticated = true
    }

  if (to.meta.requiresAuth && !isAuthenticated ) {
    next({ path: 'login', })
  }else{
     next()
  }
})

router.afterEach(async () => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
